import { render, staticRenderFns } from "./RegisterFormMitra.vue?vue&type=template&id=24cd514e"
import script from "./RegisterFormMitra.vue?vue&type=script&lang=js"
export * from "./RegisterFormMitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports